import { Component, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { AddressModel } from '../../shared/models/payment/address.model';
import { ZipCodeRangeModel } from '../../shared/models/zip-code-range.model';
import { DistanceToDeadlineService } from '../../payment/services/distance-to-deadline.service';

@Component({
    selector: 'completed-delivery-address',
    templateUrl: './completed.delivery-address.component.html',
    styleUrls: ['../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedDeliveryAddressComponent implements OnInit {
    @Input('address') address: AddressModel;
    @Input('zipCodeRange') zipCodeRange: ZipCodeRangeModel;

    public daysToDeadline: number;
    public daysToDeadlineLimit = 0;

    constructor(
        protected distanceToDeadline: DistanceToDeadlineService
    ) {
        this.daysToDeadline = 0;
    }

    ngOnInit(): void {
        this.daysToDeadline = this.distanceToDeadline.calculate(this.zipCodeRange.time_cost);
        if (this.hasDefinedLimit()) {
            this.daysToDeadlineLimit = this.distanceToDeadline.calculate(this.zipCodeRange.time_cost_limit);
        }
    }

    /**
     * This verify if zipCodeRange has deadline_limit.
     **/
    public hasDefinedLimit(): boolean {
        if (null === this.zipCodeRange.time_cost_limit) {
            return false;
        }

        const deadlineLimitDistance = this.distanceToDeadline.calculate(this.zipCodeRange.time_cost_limit);
        const deadlineDistance = this.distanceToDeadline.calculate(this.zipCodeRange.time_cost);
        const difference = (deadlineLimitDistance - deadlineDistance);

        return this.zipCodeRange.time_cost_limit !== null && difference > 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/completed/delivery-address/completed.delivery-address.component.ts